import { user } from 'core';
import { Cycle, CycleSkeleton } from 'ui/components';
import CycleControls from 'ui/components/templates/Cycle/CycleControls';
import Styles from 'ui/components/templates/Cycle/Cycle.styles';
import { getOnlyCurrentCycles } from '../../helpers';

const CycleWidget = () => {
  const {
    data: {
      cycle: { finalDate, initialDate, ...cycle },
      isMultiBrand,
      avaliableCycles,
    },
  } = user.hooks.useUser();
  if (!cycle.currentCycle) {
    return <CycleSkeleton />;
  }

  return (
    <Styles.Component
      data-testid="header-cycle"
      data-empty-cycle={isMultiBrand && !avaliableCycles?.cycles?.length}
    >
      {isMultiBrand ? (
        <CycleControls
          vdfCycles={getOnlyCurrentCycles(avaliableCycles?.cycles, cycle.currentCycle)}
        />
      ) : (
        <Cycle finalDate={finalDate} initialDate={initialDate} {...cycle} />
      )}
    </Styles.Component>
  );
};

export default CycleWidget;
